import React, { useState, FunctionComponent } from "react";
import { SidebarMenuItem } from "./";
import { SidebarMenuItem as MenuItem } from "../../constants/sidebarMenuItems";
import type { Session } from "../../modules/session";

interface NavigationMenuProps {
  items: MenuItem[];
  currentRoute: string | null;
  activeSubRoute?: string | null;
  session: Session;
  isBottomMenu?: boolean;
  isMinimized?: boolean;
  currentUserId?: string;
  currentPath?: string;
}

const NavigationMenu: FunctionComponent<NavigationMenuProps> = ({
  items,
  currentRoute,
  activeSubRoute,
  session,
  isBottomMenu = false,
  isMinimized = false,
  currentUserId,
  currentPath
}) => {
  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  // Auto-expand items that have active sub-routes
  React.useEffect(() => {
    if (activeSubRoute && currentRoute) {
      setExpandedItems(prev =>
        prev.includes(currentRoute) ? prev : [...prev, currentRoute]
      );
    }
  }, [activeSubRoute, currentRoute]);

  const toggleExpanded = (key: string) => {
    if (isMinimized) return; // Don't expand when minimized

    setExpandedItems(prev =>
      prev.includes(key)
        ? prev.filter(item => item !== key)
        : [...prev, key]
    );
  };
  const getItemBaseRoute = (route: string) => {
    // Handle home route
    if (route === "/") {
      return "home";
    }

    // Remove leading slash and get the first segment
    const cleanRoute = route.startsWith("/") ? route.substring(1) : route;
    const pathList = cleanRoute.split("/");
    return pathList.length >= 1 ? pathList[0] : null;
  };

  const isItemActive = (item: MenuItem) => {
    // Special handling for Settings menu - only active when viewing own account settings
    if (item.key === "settings" && currentUserId && currentPath) {
      return currentPath.includes("/accounts/settings/") && currentPath.includes(`/${currentUserId}`);
    }

    // Default behavior for other items
    return getItemBaseRoute(item.route) === currentRoute;
  };

  const visibleItems = items.filter(item => item.visible(session));
  return (
    <div className={`navigation-menu ${isBottomMenu ? "navigation-menu-bottom" : ""}`}>
      {visibleItems.map((item) => (
        <SidebarMenuItem
          key={item.key}
          item={item}
          isActive={isItemActive(item)}
          isExpanded={expandedItems.includes(item.key)}
          onToggleExpanded={() => toggleExpanded(item.key)}
          session={session}
          activeSubRoute={activeSubRoute}
          isMinimized={isMinimized}
        />
      ))}
    </div>
  );
};

export default NavigationMenu;
